export default __webpack_public_path__ + "static/Poppins-Italic-e373f6163127e2d469afec43433ce6ef.ttf";